/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UtenteService } from '@shared/services/utente.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-pages-home',
    templateUrl: './home.component.html',
})
export class PagesHomeComponent {

    constructor(private router: Router,
        private utenteService: UtenteService,
        private utility: UtilsService
        ) {}
    
    login() {
        window.location.href = 'api/private/auth';
    }


    public downloadManuale() {
        this.utility.downloadManuale().subscribe();
    }


}